"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "BmFlexLayoutOptions", {
  enumerable: true,
  get: function get() {
    return _renderFlexLayout.BmFlexLayoutOptions;
  }
});

_Object$defineProperty(exports, "BmFlexLayoutOptionsExt", {
  enumerable: true,
  get: function get() {
    return _renderFlexLayout.BmFlexLayoutOptionsExt;
  }
});

_Object$defineProperty(exports, "BmFlexLayout", {
  enumerable: true,
  get: function get() {
    return _renderFlexLayout.BmFlexLayout;
  }
});

_Object$defineProperty(exports, "renderFlexLayout", {
  enumerable: true,
  get: function get() {
    return _renderFlexLayout.renderFlexLayout;
  }
});

_Object$defineProperty(exports, "registerFlexLayout", {
  enumerable: true,
  get: function get() {
    return _renderFlexLayout.registerFlexLayout;
  }
});

_Object$defineProperty(exports, "BmGridPositionOptions", {
  enumerable: true,
  get: function get() {
    return _renderGridLayout.BmGridPositionOptions;
  }
});

_Object$defineProperty(exports, "BmGridLayoutOptions", {
  enumerable: true,
  get: function get() {
    return _renderGridLayout.BmGridLayoutOptions;
  }
});

_Object$defineProperty(exports, "BmGridLayout", {
  enumerable: true,
  get: function get() {
    return _renderGridLayout.BmGridLayout;
  }
});

_Object$defineProperty(exports, "renderGridLayout", {
  enumerable: true,
  get: function get() {
    return _renderGridLayout.renderGridLayout;
  }
});

_Object$defineProperty(exports, "registerGridLayout", {
  enumerable: true,
  get: function get() {
    return _renderGridLayout.registerGridLayout;
  }
});

_Object$defineProperty(exports, "BmExpansionLayoutOptions", {
  enumerable: true,
  get: function get() {
    return _renderExpansionPanelLayout.BmExpansionLayoutOptions;
  }
});

_Object$defineProperty(exports, "defaultBmExpansionLayoutOpts", {
  enumerable: true,
  get: function get() {
    return _renderExpansionPanelLayout.defaultBmExpansionLayoutOpts;
  }
});

_Object$defineProperty(exports, "registerBmExpansionPanelLayout", {
  enumerable: true,
  get: function get() {
    return _renderExpansionPanelLayout.registerBmExpansionPanelLayout;
  }
});

_Object$defineProperty(exports, "renderBmExpansionPanelLayout", {
  enumerable: true,
  get: function get() {
    return _renderExpansionPanelLayout.renderBmExpansionPanelLayout;
  }
});

_Object$defineProperty(exports, "BmVariableGridLayout", {
  enumerable: true,
  get: function get() {
    return _renderVariableGrid.BmVariableGridLayout;
  }
});

_Object$defineProperty(exports, "registerBmVariableGridLayoutElement", {
  enumerable: true,
  get: function get() {
    return _renderVariableGrid.registerBmVariableGridLayoutElement;
  }
});

_Object$defineProperty(exports, "renderBmVariableGridLayout", {
  enumerable: true,
  get: function get() {
    return _renderVariableGrid.renderBmVariableGridLayout;
  }
});

_Object$defineProperty(exports, "getVariableGridStyles", {
  enumerable: true,
  get: function get() {
    return _renderVariableGrid.getVariableGridStyles;
  }
});

_Object$defineProperty(exports, "registerBmVariableGridLayout", {
  enumerable: true,
  get: function get() {
    return _renderVariableGrid.registerBmVariableGridLayout;
  }
});

_Object$defineProperty(exports, "renderLayout", {
  enumerable: true,
  get: function get() {
    return _renderLayout.renderLayout;
  }
});

_Object$defineProperty(exports, "BmFormLayout", {
  enumerable: true,
  get: function get() {
    return _renderLayout.BmFormLayout;
  }
});

_Object$defineProperty(exports, "BmVariableLayoutOptions", {
  enumerable: true,
  get: function get() {
    return _renderVariableLayout.BmVariableLayoutOptions;
  }
});

_Object$defineProperty(exports, "defaultBmVariableLayoutOpts", {
  enumerable: true,
  get: function get() {
    return _renderVariableLayout.defaultBmVariableLayoutOpts;
  }
});

_Object$defineProperty(exports, "BmVariableLayoutModalAddOptions", {
  enumerable: true,
  get: function get() {
    return _renderVariableLayout.BmVariableLayoutModalAddOptions;
  }
});

_Object$defineProperty(exports, "defaultModalAddOptions", {
  enumerable: true,
  get: function get() {
    return _renderVariableLayout.defaultModalAddOptions;
  }
});

_Object$defineProperty(exports, "BmVariableLayoutInfo", {
  enumerable: true,
  get: function get() {
    return _renderVariableLayout.BmVariableLayoutInfo;
  }
});

_Object$defineProperty(exports, "BmVariableLayout", {
  enumerable: true,
  get: function get() {
    return _renderVariableLayout.BmVariableLayout;
  }
});

exports.registerBmFormCoreLayouts = void 0;

var _renderFlexLayout = require("./render-flex-layout");

var _renderGridLayout = require("./render-grid-layout");

var _renderExpansionPanelLayout = require("./render-expansion-panel-layout");

var _renderVariableGrid = require("./render-variable-grid");

var _renderLayout = require("./render-layout");

var _renderVariableLayout = require("./render-variable-layout");

var registerBmFormCoreLayouts = function registerBmFormCoreLayouts() {
  (0, _renderFlexLayout.registerFlexLayout)();
  (0, _renderGridLayout.registerGridLayout)();
  (0, _renderExpansionPanelLayout.registerBmExpansionPanelLayout)();
  (0, _renderVariableGrid.registerBmVariableGridLayout)();
};

exports.registerBmFormCoreLayouts = registerBmFormCoreLayouts;
